import type { PageTabWithId } from "@kontextwerk/web-sdk/core/navigation/viewNavigation"
import { PERMISSION_SECTIONS } from "../../../../_shared/_logic/permission-sections"

/** The basic platform grants share the "Allgemein" tab with the role itself. */
export const GENERAL_PERMISSION_SECTION_ID = "core"

export const getTabs = (): PageTabWithId[] => [
  { id: "general", title: "Allgemein", widthType: "small" },
  ...PERMISSION_SECTIONS.filter((section) => section.id !== GENERAL_PERMISSION_SECTION_ID).map(
    (section): PageTabWithId => ({ id: section.id, title: section.title, widthType: "small" }),
  ),
]
